function cov_2k4ow4gevp() {
  var path = "/app/src/hooks/use-svg-id.ts";
  var hash = "e2da32bdc7ec1b01d93e0fc8d11b5c1821eaec58";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/hooks/use-svg-id.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 24
        },
        end: {
          line: 4,
          column: 47
        }
      },
      "1": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 4,
          column: 47
        }
      },
      "2": {
        start: {
          line: 4,
          column: 16
        },
        end: {
          line: 4,
          column: 40
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 24
          },
          end: {
            line: 3,
            column: 25
          }
        },
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 4,
            column: 47
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 4,
            column: 10
          },
          end: {
            line: 4,
            column: 11
          }
        },
        loc: {
          start: {
            line: 4,
            column: 16
          },
          end: {
            line: 4,
            column: 40
          }
        },
        line: 4
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e2da32bdc7ec1b01d93e0fc8d11b5c1821eaec58"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2k4ow4gevp = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2k4ow4gevp();
import { useMemo } from 'react';
cov_2k4ow4gevp().s[0]++;
export var useSvgId = function useSvgId(id) {
  cov_2k4ow4gevp().f[0]++;
  cov_2k4ow4gevp().s[1]++;
  return useMemo(function () {
    cov_2k4ow4gevp().f[1]++;
    cov_2k4ow4gevp().s[2]++;
    return "".concat(id, "_").concat(Math.random());
  }, [id]);
};